import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface InventoryRoomForCleaner {
  id: string;
  property_id: string;
  name: string;
  order_index: number;
  entry_code?: string | null;
  entry_notes?: string | null;
}

export const useInventoryRoomsForCleaner = (propertyId: string | undefined) => {
  return useQuery({
    queryKey: ["inventory-rooms-cleaner", propertyId],
    queryFn: async () => {
      if (!propertyId) return [];
      const { data, error } = await supabase
        .from("inventory_rooms")
        .select("*")
        .eq("property_id", propertyId)
        .order("order_index", { ascending: true });

      if (error) throw error;
      return data as InventoryRoomForCleaner[];
    },
    enabled: !!propertyId,
  });
};
